import { render, staticRenderFns } from "./SectionElement.vue?vue&type=template&id=0bce2b9a"
import script from "./SectionElement.vue?vue&type=script&lang=js"
export * from "./SectionElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports